import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// @ts-ignore
import { submittingSelectors } from 'shared';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventsProps } from 'services/harvestEvents/types';

// Global Components
import StatusIcon from 'components/StatusIcon';

// Global Selectors
import {
    makeSelectHarvestEventErrorMessageExists,
    makeSelectHarvestEventHasUnsavedChanges
} from 'services/harvestEvents/selectors';

interface OwnProps extends HarvestEventsProps {
    withText?: boolean;
}

interface ConnectedProps {
    hasUnsavedChanges?: boolean;
    isSubmitting?: boolean;
    errorMessageExists?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventUploadStatusComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const {
            hasUnsavedChanges,
            isSubmitting,
            errorMessageExists,
            withText
        } = this.props;

        // Display saved status if there are no unsaved changes
        if (!hasUnsavedChanges) {
            return <StatusIcon status="SAVED_ONLINE" withText={withText} />;
        }

        // Display updating status is unsaved changes exist and are submitting
        if (isSubmitting) {
            return <StatusIcon status="UPDATING" withText={withText} />;
        }

        // Display upload failed status is unsaved changes exist and an error get returned with a 200 from the bulk endpoint.
        if (errorMessageExists) {
            return <StatusIcon status="UPLOAD_FAILED" withText={withText} />;
        }

        return <StatusIcon status="OFFLINE_ONLY" withText={withText} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    hasUnsavedChanges: makeSelectHarvestEventHasUnsavedChanges(),
    isSubmitting: submittingSelectors.makeSelectSubmitting(
        'HARVEST_EVENTS_SAVE'
    ),
    errorMessageExists: makeSelectHarvestEventErrorMessageExists()
});

export default connect(mapStateToProps)(HarvestEventUploadStatusComponent);
